import { useCallback, useState } from 'react';
import { api, ApiError } from '../../../lib/api';
import { friendlyError } from '../model/flow';
import { GM } from '../model/copy';

/** "Remind me" for an upcoming Grand Mock: busy and error state, and whether it was just set. */
export function useRemind(reload: () => void) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [remindedNow, setRemindedNow] = useState(false);
  const remind = useCallback(
    async (gmId: string) => {
      setBusy(true);
      setError(null);
      try {
        await api('POST', `/app/grand-mock/${gmId}/remind`);
        setRemindedNow(true);
        reload();
      } catch (e) {
        setError(e instanceof ApiError ? friendlyError(e.code, e.message) : GM.loadError);
      } finally {
        setBusy(false);
      }
    },
    [reload],
  );
  return { remind, busy, error, remindedNow };
}
